import { pmpDealType } from '@openx/types/deal';
import { useReducer } from 'react';

export const useFieldsVisibility = () => {
  const initialState = {
    showImpression: false,
    showMaxFloor: false,
  };

  function reducer(_state, action) {
    switch (action) {
      case pmpDealType.PreferredDeal:
        return { ...initialState };
      case pmpDealType.WithinOpenAuction:
        return { ...initialState, showMaxFloor: true };
      case pmpDealType.PrivateAuction:
        return { ...initialState, showMaxFloor: true };
      case pmpDealType.Guaranteed:
        return { ...initialState, showImpression: true };
      default:
        return initialState;
    }
  }

  const [stateFieldsVisibility, dispatchFieldsVisibilityChange] = useReducer(reducer, initialState);
  return { dispatchFieldsVisibilityChange, stateFieldsVisibility };
};
